import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { DefaultSearch } from '../interfaces/zoneInterface'

interface State {
  isUsedAutocomplete: boolean
  defaultSearches: DefaultSearch[]
}

interface Setters {
  setIsUsedAutocomplete: (value: boolean) => void
  setDefaultSearches: (value: DefaultSearch[]) => void
}

const initialState: State = {
  isUsedAutocomplete: false,
  defaultSearches: []
}

export const useColdStartStore = create(
  persist<State & Setters>(
    (set) => ({
      ...initialState,
      setIsUsedAutocomplete: (value) =>
        set(() => ({
          isUsedAutocomplete: value
        })),
      setDefaultSearches: (value) =>
        set(() => ({
          defaultSearches: value
        }))
    }),
    {
      name: 'autocomplete-cold-start-store',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)
